const subscriptionDE = {
    "view": {
        "table": {
            "title": "Ihr Abonnement",
            "column": {
                "subscriptionTier": "Abonnementstufe",
                "startDate": "Startdatum",
                "currentPeriodStart": "Aktueller Zeitraum Beginn",
                "currentPeriodEnd": "Aktueller Zeitraum Ende",
                "autoRenewal": "Automatische Verlängerung",
                "status": "Status",
                "action": "Aktion"
            },
            "label": {
                "status_active": "Aktiv",
                "status_incomplete": "Unvollständig",
                "status_incomplete_expired": "Unvollständig Abgelaufen",
                "status_unpaid": "Unbezahlt",
                "status_past_due": "Überfällig",
                "status_cancelled": "Storniert",
                "status_expired": "Abgelaufen"
            },
            "actionDropdown": {
                "label": {
                    "action": "Aktion"
                },
                "button": {
                    "enableAutoRenewal": "Automatische Verlängerung aktivieren",
                    "upgradeSubscription": "Abonnement upgraden",
                    "cancelSubscription": "Abonnement kündigen",
                    "resumeSubscription": "Abonnement fortsetzen",
                    "retryPayment": "Zahlung erneut versuchen"
                },
                "message": {
                    "successSubscripionResumed": "Ihr Abonnement wurde fortgesetzt, Ihr Konto wird in Kürze aktualisiert!",
                    "successSubscripionCancelled": "Ihr Abonnement wurde zur Kündigung am Ende des Zeitraums festgelegt!",
                    "successSubscripionAutoRenewalEnabled": "Ihr Abonnement wurde zur automatischen Verlängerung am Ende des Zeitraums festgelegt!",
                    "activeSubscription": "Sie haben bereits ein aktives Abonnement",
                    "incompleteSubscription": "Sie haben ein Abonnement, das unvollständig ist."
                }
            },
            "modal": {
                "button": {
                    "cancel": "Abbrechen",
                    "enableAutoRenewal": "Automatische Verlängerung aktivieren",
                    "cancelSubscription": "Abonnement kündigen"
                }
            }
        },
        "modal": {
            "enableAutoRenewal": {
                "header": "Automatische Verlängerung aktivieren",
                "body": "Sind Sie sicher, dass Sie die automatische Verlängerung für Ihr Abonnement aktivieren möchten?"
            },
            "cancel": {
                "header": "Abonnement kündigen",
                "body": "Sind Sie sicher, dass Sie Ihr Abonnement kündigen möchten?"
            },
            "resume": {
                "header": "Abonnement fortsetzen",
                "body": {
                    "description": "Sind Sie sicher, dass Sie das Abonnement fortsetzen möchten?",
                    "note": "<strong>Hinweis:</strong> Der neueste Abonnementpreis gilt!"
                },
                "button": {
                    "cancel": "Abbrechen",
                    "resume": "Fortsetzen"
                },
                "message": {
                    "error": "Etwas ist schief gelaufen! Bitte Seite aktualisieren und erneut versuchen!"
                }
            },
            "retryPayment": {
                "header": "Abonnementzahlung erneut versuchen",
                "body": {
                    "description": "Sind Sie sicher, dass Sie die Zahlung für das Abonnement erneut versuchen möchten?",
                    "note": "<strong>Hinweis:</strong> Der neueste Abonnementpreis gilt!"
                },
                "button": {
                    "cancel": "Abbrechen",
                    "retry": "Erneut versuchen"
                },
                "message": {
                    "error": "Etwas ist schief gelaufen! Bitte Seite aktualisieren und erneut versuchen!"
                }
            }
        },
        "message": {
            "errorPaymentFailed": "Abonnementzahlung fehlgeschlagen, bitte versuchen Sie es später erneut!",
            "errorCardExpired": "Ihre Karte ist abgelaufen. Bitte fügen Sie eine gültige Standard-<1>Zahlungsmethode</1> hinzu und versuchen Sie die Zahlung erneut.",
            "errorNoPaymentMethod": "Sie haben keine <1>Zahlungsmethode</1> zu Ihrem Profil hinzugefügt. Bitte fügen Sie eine gültige Standard-<3>Zahlungsmethode</3> hinzu und versuchen Sie die Zahlung erneut.",
            "moduleNoAccess": "Sie haben keinen Zugriff auf dieses Modul, bitte kontaktieren Sie das Support-Team für weitere Informationen."
        }
    },
    "subscriptionTiers": {
        "form": {
            "title": "Wählen Sie Ihren Plan",
            "button": {
                "startNow": "Jetzt starten"
            }
        },
        "message": {
            "error": "Etwas ist schief gelaufen! Bitte Seite aktualisieren und erneut versuchen!"
        }
    },
    "upgrade": {
        "form": {
            "title": "Ihr Abonnement upgraden",
            "button": {
                "upgrade": "Upgrade",
                "currentPlan": "Aktueller Plan"
            }
        },
        "modal": {
            "upgradeSubscription": {
                "header": "Abonnement upgraden",
                "body": {
                    "description": "Sind Sie sicher, dass Sie Ihren Abonnementplan auf <strong>{{newTierName}}</strong> upgraden möchten.",
                    "note": "<strong>Hinweis: Der Abrechnungszeitraum für das Abonnement bleibt unverändert und Sie werden nur für den Betrag in Rechnung gestellt, der den bereits für den bestehenden Plan gezahlten Betrag ausschließt.</strong>"
                },
                "button": {
                    "cancel": "Abbrechen",
                    "confirm": "Bestätigen"
                }
            }
        },
        "message": {
            "error": "Etwas ist schief gelaufen! Bitte Seite aktualisieren und erneut versuchen!",
            "moduleNoAccess": "Sie haben keinen Zugriff auf dieses Modul, bitte kontaktieren Sie das Support-Team für weitere Informationen."
        }
    },
    "confirmModal": {
        "header": "Bestätigen Sie Ihre Informationen",
        "body": {
            "form": {
                "label": {
                    "firstName": "Vorname",
                    "lastName": "Nachname",
                    "country": "Wohnsitzland",
                    "refundPolicyAgreement": "Mit dem Fortfahren erkenne ich an und akzeptiere, dass diese Zahlung endgültig und nicht erstattungsfähig ist. <1>Rückerstattungsrichtlinie</1>",
                },
                "help_text": {
                    "firstName": "Bitte bestätigen Sie, dass dies Ihr gesetzlicher Vorname ist.",
                    "lastName": "Bitte bestätigen Sie, dass dies Ihr gesetzlicher Nachname ist.",
                    "country": "Bitte geben Sie Ihr aktuelles Wohnsitzland an.",
                },
                "message": {
                    "error": "Fehler beim Erstellen des Abonnements!",
                    "note": "Hinweis: Die Genauigkeit der hier angegebenen Informationen ist für die nachfolgenden Schritte entscheidend. Stellen Sie sicher, dass alle Informationen genau und wahrheitsgemäß angegeben werden."
                }
            }
        },
        "button": {
            "cancel": "Abbrechen",
            "confirm": "Bestätigen"
        }
    },
    "upgradeFailure": {
        "view": {
            "title": "Abonnement-Upgrade fehlgeschlagen :(",
            "description": "Es gab ein Problem beim Upgrade Ihres Abonnements. Bitte versuchen Sie es später erneut!",
            "button": {
                "returnToDashboard": "Zurück zum Dashboard"
            }
        }
    },
    "upgradeSuccess": {
        "view": {
            "title": "Abonnement erfolgreich upgegradet :)",
            "description": "Sie haben Ihr Abonnement erfolgreich upgegradet, Ihr Konto wird in Kürze aktualisiert!",
            "button": {
                "returnToDashboard": "Zurück zum Dashboard"
            }
        }
    },
    "transactionFailure": {
        "view": {
            "title": "Transaktion abgebrochen :(",
            "description": "Die Transaktion wurde abgebrochen... Bitte versuchen Sie es später erneut!",
            "button": {
                "returnToDashboard": "Zurück zum Dashboard"
            }
        }
    },
    "transactionSuccess": {
        "view": {
            "title": "Transaktion erfolgreich :)",
            "description": "Sie haben Ihr Abonnement erfolgreich bestätigt, Ihr Konto wird in Kürze upgegradet!",
            "button": {
                "returnToDashboard": "Zurück zum Dashboard"
            }
        }
    }
};

export default subscriptionDE;